import dayjs from "dayjs";
import { useEffect, useState, useRef } from "react";
import { useSession } from "next-auth/react";

const COMPARE_FORMAT = "YYYY-MM-DD";

const locales = {
  cs: import("dayjs/locale/cs"),
  en: import("dayjs/locale/en"),
  sk: import("dayjs/locale/sk"),
};

const HorizontalCalendar = (props) => {
  const { data: session } = useSession();
  const currentDateRef = useRef(null);
  const scrollableDivRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(props.startDate);
  const [renderDaysAfter, setRenderDaysAfter] = useState(props.renderDaysAfter || 90);
  const [renderDaysBefore, setRenderDaysBefore] = useState(props.renderDaysBefore || 90);
  const [firstDate, setFirstDate] = useState(props.startDate.subtract(renderDaysBefore, "days"));
  const [lastDate, setLastDate] = useState(props.startDate.add(renderDaysAfter + 1, "days"));
  const [arrayDates, setArrayDates] = useState([]);

  const executeScroll = () => {
    const date = document.getElementById(selectedDate.format(COMPARE_FORMAT));
    if (!date) return;
    const div = document.getElementById("scroll");
    const position = date.getBoundingClientRect();
    div.scrollTo(position.left - window.innerWidth / 2 + 30, 0); // get element X position and scroll to window width / 2
  };

  const handleDateClick = (date) => {
    if (date.format(COMPARE_FORMAT) !== selectedDate.format(COMPARE_FORMAT)) {
      setSelectedDate(date);
      props.onDateChange(date);
    }
  };

  useEffect(() => {
    const result = [];
    let date = firstDate;

    while (dayjs(date).isBefore(lastDate)) {
      result.push(date);
      date = date.add(1, "day");
    }

    setArrayDates(result);
  }, [firstDate, lastDate]);

  useEffect(() => {
    if (arrayDates) {
      executeScroll();
    }
  }, [arrayDates]);

  useEffect(() => {
    const scrollDiv = scrollableDivRef.current;
    if (scrollDiv) {
      scrollDiv.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollDiv.scrollLeft += evt.deltaY;
      });
    }
  }, []);

  const isWeekendDay = (date) => date.day() == 0 || date.day() == 6; // Saturday or Sunday
  const isStartOfMonth = (date) => date.startOf("month").format(COMPARE_FORMAT) == date.format(COMPARE_FORMAT);

  const getBtnTextColorByDay = (date) => {
    if (date.format(COMPARE_FORMAT) === dayjs().format(COMPARE_FORMAT)) {
      return "text-accent1";
    } else if (date.isAfter(dayjs())) {
      return "text-dark1";
    }

    return "text-gray2";
  };

  const getLabelTextColorByDay = (date) => {
    if (date.format(COMPARE_FORMAT) === dayjs().format(COMPARE_FORMAT)) {
      return "text-accent1";
    } else if (isWeekendDay(date) && date.isAfter(dayjs())) {
      return "text-dark1";
    } else if (isWeekendDay(date) && date.isBefore(dayjs())) {
      return "text-gray1";
    }

    return "text-gray2";
  };

  const getBackgroundByDay = (date) => {
    const dateFormatted = date.format(COMPARE_FORMAT);
    if (selectedDate?.format(COMPARE_FORMAT) == dateFormatted) {
      return "btn-primary btn-day-active";
    } else if (dateFormatted == dayjs().format(COMPARE_FORMAT)) {
      return "btn-secondary text-black";
    }
    return "";
  };

  const getBorderColorByDay = (date) => {
    if (date.isBefore(dayjs().subtract(1, "day"))) {
      return "border-2";
    } else {
      return "border-2 border-secondary-color";
    }
  };

  return (
    <>
      <div
        className="calendar-horizontal fixed-top overflow-scroll pb-12 border-bottom mb-2 container hide-scrollbars"
        style={{ zIndex: 1000 }}
        id="scroll"
        ref={scrollableDivRef}
      >
        <div className="btn-group">
          {arrayDates.map((date) => (
            <div
              key={date}
              ref={date.format(COMPARE_FORMAT) == props.selectedDate?.format(COMPARE_FORMAT) ? currentDateRef : null}
              id={date.format(COMPARE_FORMAT)}
              className="text-center small me-1"
            >
              <small className={`text-uppercase label-4 d-block mb-2 ${getLabelTextColorByDay(date)}`}>
                {date.locale(session?.user?.locale || "en").format("ddd")}
              </small>
              <button
                onClick={() => handleDateClick(date)}
                className={`rounded-circle border btn btn-sm btn-day ${getBorderColorByDay(date)} ${getBackgroundByDay(
                  date
                )} ${getBtnTextColorByDay(date)}`}
              >
                {date.format("D")}
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HorizontalCalendar;
